import React, { createContext } from "react";
import { CannyService } from "./CannyService";

type CannyProviderProps = {
    children?: React.ReactNode;
};

export const CannyContext = createContext<CannyService | null>(null);

export function CannyProvider({ children }: CannyProviderProps) {
    const canny = CannyService();

    return <CannyContext.Provider value={canny}>{children}</CannyContext.Provider>;
}

export function useCanny() {
    const context = React.useContext(CannyContext);
    if (context == null) {
        throw new Error("useCanny must be used within a CannyProvider");
    }
    return context;
}
